import React from "react";
import { colorList } from "variables/colors";
import { round } from "utils/Utils";

import {
  Input,
  Label,
  FormGroup,
} from "reactstrap";

const CustomInputElement = (
  {
    requiredState = "",
    label,
    placeHolder,
    inputType = 'text',
    readOnly = false,
    value = '',
    onChange,
    style,
    formGroupClass = "",
    formGroupStyle = {},
    labelMargin,
    ...props
  }) => {

  return (
    <>

      <FormGroup className={`${requiredState} ${formGroupClass}`} style={formGroupStyle}>
        <Label style={{ color: colorList.fontColor, fontWeight: '600', fontSize: '10.5px', margin: labelMargin }} >{label}</Label>

        <Input
          type={inputType}
          placeholder={placeHolder}
          value={value !== '' ? round(value, 2) : value}
          onChange={onChange}
          readOnly={readOnly}
          style={{ 
            ...(style ? style : value ? { color: 'black', fontWeight: '600' } : null),
            fontSize: '12px'
          }}
        />
        {
          requiredState === "has-danger" ? (
            <label className='error'>
              This field is required.
            </label>
          ) : null}


        {/* <Label><strong className='text-info' > Hint: {'Input the values of'}</strong></Label> */}

      </FormGroup>
    </>
  );
};

export default CustomInputElement;